import { Box, Button, TableContainer, TextField } from "@mui/material";
import { styled } from "@mui/system";
import { Colors } from "../theme/index";
import { yellow } from "@mui/material/colors";

export const AddButtonContainer = styled('div')(() => ({
  display: "flex",
  justifyContent: "space-between", // spread header and button to edges
  alignItems: "center",
  marginBottom: "16px",
  position: "sticky",
  top: "0",
  zIndex: 10,
  backgroundColor: "#fff",
  padding: "10px",
  width: "100%", // full width so space-between works

  "@media (max-width: 768px)": {
    flexDirection: "column",       // stack vertically on mobile
    alignItems: "flex-start",      // align items to start when stacked
    gap: "10px",                   // spacing between items
    position: "static",
  },
}));



export const CommanTableContain = styled(TableContainer)(() => ({
  maxHeight: "400px", // Set a maximum height for the table
  border: "1px solid rgba(224, 224, 224, 1)", // Add a border around the entire table
  borderRadius: "5px", // Optional: Add rounded corners
  overflowY: "auto", // Enable vertical scrolling
  overflowX: "auto",
  marginTop: "10px",
  // Enable horizontal scrolling
  "& table": {
    width: "100%", // Ensure the table takes up the full width
    borderCollapse: "collapse", // Ensure borders collapse for a cleaner look
  },
  "& table tr th,& table tr td": {
    borderRight: "1px solid rgba(224, 224, 224, 1)",
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
    borderLeft: "none",
    borderTop: "none", // Remove the top border
    textAlign: "center",
    textTransform: "capitalize",
  },
  "& table thead tr:first-of-type th": {
    borderTop: "none", // Remove the top border for the header row
    // backgroundColor: "blue", // Ensure the header has a solid background color
    color: Colors.black,
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
    backgroundColor: "#bec4cb",
    whiteSpace: "nowrap",
    position: "sticky", // Make the header sticky
    top: 0, // Stick to the top
    zIndex: 3, 
    fontWeight: "bold",// Ensure it stays above other elements
    "& span": {
      fontSize: "12px",
      display: "block",
    },
  },
  "& table tr td:first-of-type, & table tr th:first-of-type": {
    position: "sticky", // Make the first column sticky
    left: 0, // Stick to the left
    zIndex: 4, // Ensure it stays above other elements
    // backgroundColor: "red", // Match the background color
    backgroundColor: "white",
    borderBottom: "none",
    borderRight: "none",
    borderTop: "none", // Remove the top border for the first column
    // Remove the bottom border for the first column

    outline: " 0.1px solid rgba(224, 224, 224, 1)",
    // Add a left border for the first column
  },
  "& table thead tr:first-of-type th:first-of-type": {
    position: "sticky", // Make the top-left cell sticky
    left: 0, // Stick to the left
    top: 0, // Stick to the top
    zIndex: 5, // Ensure it stays above all other cells
    // backgroundColor: "yellow", // Set the background color to yellow
    backgroundColor: "#bec4cb",
     // Add a left border
      // Add a top border
  },

  "& table tr td": {
    backgroundColor: "#fff",
    padding: "7px",
    "& button.action": {
      color: "#000",
      border: "none",
      outline: "none",
      padding: "7px 15px",
      borderRadius: "5px",
      fontSize: "12px",
      height: "30px",
      "&.save": {
        color: "#fff",
        backgroundColor: "#009000",
      },
    },
    "& a": {
      fontSize: "12px",
      color: "#007FFF",
    },
    "& input,& textarea, & select": {
      fontSize: "12px",
      width: "100%",
      padding: "5px",
      borderRadius: "5px",
    },
    "& .MuiStack-root": {
      padding: "0",
      "& .MuiFormControl-root": {
        minWidth: "150px",
        maxWidth: "150px",
        margin: "auto",
        border: "1px solid rgba(0, 0, 0, 0.23)",
        borderRadius: "5px",
        "& label": {
          fontSize: "11px",
          top: "-5px",
        },
        "& .MuiInputBase-input": {
          padding: "9px 14px",
          height: "auto",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          display: "none",
        },
      },
    },
  },
  "& table tr:last-of-type td": {
    borderBottom: "1px solid rgba(224, 224, 224, 1)", // Remove the bottom border for the last row
  },
  "& table tr": {
    "&:hover": {
      "& td.Form_accepted,& td.Form_submitted": {
        backgroundColor: Colors.formAcceptedBg,
      },
      "& td.Form_in-process,& td.Form_reconsideration": {
        backgroundColor: Colors.formInprocessBg,
      },
      "& td.Form_pending": {
        backgroundColor: Colors.formInprocessBg,
      },
    },
    "& td": {
      "&.Form_accepted,&.Form_submitted": {
        color: Colors.formAccepted,
      },
      "&.Form_in-process,&.Form_reconsideration": {
        color: Colors.formInprcess,
      },
      "&.Form_pending": {
        color: Colors.formPending,
      },
    },
  },

  "& .icon-done": {
    color: "green",
    cursor: "pointer",
    fontSize: "20px", // Adjust the size if needed
  },
  "& .icon-close": {
    color: "red",
    cursor: "pointer",
    fontSize: "20px", // Adjust the size if needed
  },
  "& .icon-edit": {
    color: "blue",
    cursor: "pointer",
    fontSize: "20px", // Adjust the size if needed
  },
  "& .icon-delete": {
    color: "red",
    cursor: "pointer",
    fontSize: "20px", // Adjust the size if needed
  },
  '& .styled_text_field':{
    width: "100%", // Ensure the input field takes up the full width of the cell
  "& .MuiInputBase-root": {
    fontSize: "1rem", // Adjust font size for a medium appearance
    padding: "4px", // Adjust padding for a medium appearance
    borderRadius: "5px", // Optional: Add rounded corners
    border: "1px solid rgba(224, 224, 224, 1)",
     // Optional: Add a border
  },
  }
}));

export const SmartSearchContain = styled(Box)(() => ({
  width: "200px",
  position: "relative",
  "& .MuiFormControl-root": {
    margin: "0 2px",
  },
  "& label": {
    fontSize: "12px",
  },
  paddingRight: "25px",
  "& input": {
    fontSize: "12px",
    paddingRight: "25px",
    backgroundColor: "#fff",
    "&::placeholder": {
      fontSize: "12px",
    },
  },
  "& svg": {
    position: "absolute",
    right: "3px",
    top: "7px",
    color: Colors.light_gray,
  },
}));

export const PaginationContain = styled(Box)(() => ({
  borderBottom: "1px solid rgba(224, 224, 224, 1)", 
  borderRight: "1px solid rgba(224, 224, 224, 1)",
  borderLeft: "1px solid rgba(224, 224, 224, 1)",
  // Add a border around the entire pagination
  borderRadius: "5px", // Optional: Add rounded corners
  padding: "0.2px 0", // Reduce vertical padding to decrease height
  "& .MuiTablePagination-select": {
    zIndex: 11,
  },
}));

export const PdfButton = styled(Button)(() => ({
  backgroundColor: "transparent",
  minWidth: "30px",
  borderRadius: "5px",
  color: Colors.pending,
}));

export const ContainerCustom = styled(Box)(() => ({
  display: "flex",
  justifyContent: "end",
  alignItems: "center",
  backgroundColor: "#f5f5f5",
  marginBottom: "10px",
  padding: "0",
  borderRadius: "5px",
}));

export const TableModal = styled(Box)(() => ({
  maxWidth: "550px",
  width: "100%",
  maxHeight: "500px",
  backgroundColor: Colors.white,
  display: "flex",
  flexDirection: "column",
  "& .ModalHeader": {
    backgroundColor: Colors.primary,
    color: Colors.white,
    fontSize: "14px",
    position: "relative",
    padding: "15px",
    "& .Title": {
      paddingRight: "30px",
    },
    "& .CloseButton": {
      position: "absolute",
      right: "5px",
      top: "8px",
      width: "30px",
      height: "30px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "transparent",
      color: Colors.white,
      "& svg": {
        color: "inherit",
      },
    },
  },
  "& .ModalBody": {
    padding: "10px",
    overflow: "hidden",
    flex: "1 1 auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "420px",
    "& img": {
      maxWidth: "530px",
      width: "100%",
      maxHeight: "400px",
      objectFit: "contain",
    },
  },
}));

export const StatusSwitchContainer = styled(Box)(() => ({
  ' & .switch_button': { 
    backgroundColor: yellow,
  },
  display: "flex",
  alignItems: "center",
  justifyContent: "center", // Center the switch horizontally
}));

export const StyledTextField = styled(TextField)(() => ({
  width: "100%", // Ensure the input field takes up the full width of the cell
  "& .MuiInputBase-root": {
    fontSize: "1rem", // Adjust font size for a medium appearance
    padding: "4px", // Adjust padding for a medium appearance
    borderRadius: "5px", // Optional: Add rounded corners
    border: "1px solid rgba(224, 224, 224, 1)", // Optional: Add a border
  },
}));

export const IconStyles = styled(Box)(() => ({
  display: "flex", // Use flexbox for alignment
  justifyContent: "center", // Center icons horizontally
  alignItems: "center", // Center icons vertically
  gap: "30px", // Add space between icons
  "& .icon-done": {
    color: "green",
    cursor: "pointer",
    fontSize: "20px", // Adjust the size if needed
  },
  "& .icon-close": {
    color: "red",
    cursor: "pointer",
    fontSize: "20px", // Adjust the size if needed
  },
}));

export const StyledAddButton = styled(Button)(() => ({
  backgroundColor: Colors.primary,
   
}));

export const ModalContain = styled(Box)(() => ({
  backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent black background
  display: "flex",
  alignItems: "center", // Center the modal vertically
  justifyContent: "center", // Center the modal horizontally
  padding: "10px",
  position: "fixed",
  right: "0",
  top: "0",
  bottom: "0",
  width: "100%",
  height: "100vh",
  zIndex: 1011,
}));

export const ActionModal = styled(Box)(() => ({
  position: "fixed",
  zIndex: 1000,
  width: "300px",
  height: "250px",
  backgroundColor: "#fff",
  borderRadius: "10px",
  padding: "10px",
  display: "flex",
  flexDirection: "column",
  right: "30%",
  alignItems: "center",
  marginLeft:" 350px",
  justifyContent: "center", // Center content vertically
  gap: "25px",
  "& .IconContain": {
    textAlign: "center",
    boxShadow:
      "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
    width: "75px",
    height: "75px",
    backgroundColor: "#fff",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "-45px",
    "& svg": {
      fontSize: "45px",
      color: "red",
    },
  },
  "& .Title": {
    fontSize: "20px",
    textAlign: "center",
  },
  "& p": {
    fontSize: "12px",
    color: "gray",
  },
  "& .ButtonContain": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    letterSpacing: "1px",
    "& button": {
      border: "none",
      width: "100px",
      height: "35px",
      textAlign: "center",
      fontSize: "13px",
      "&.Delete": {
        backgroundColor: "red",
        color: "#fff",
        // 0000001c
      },
      "&.Cancel": {
        backgroundColor: "#fff",
        color: "#000",
      },
    },
  },
}));